import Vue from "vue";
import "babel-polyfill";
import "normalize.css/normalize.css";
import "animate.css/animate.css";
import App from "./App.vue";
// import router from './router'
import store from "./store";
import "./plugins/element.js";
import "./router/permission";
import "@/components";
import "@/directive";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import echarts from "echarts";
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
});
// 使用公共函数变量
import publicFunc from './utils/publicFunc'
Vue.use(publicFunc)

function loadConfig() {
  let ele = document.createElement("script");
  ele.setAttribute("src", "./config.js");
  document.body.appendChild(ele);
  return new Promise(r => {
    ele.onload = () => r(true);
  });
}
(async function() {
  await loadConfig();
  const router = require("./router");
  new Vue({
    router: router.default,
    store,
    render: function(h) {
      return h(App);
    },
    mounted() {
      // You'll need this for renderAfterDocumentEvent.
      document.dispatchEvent(new Event("render-event"));
    }
  }).$mount("#app");
})();
